var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import React, { Component } from 'react';
import { ReactComponent as Blocked } from '../../assets/images/global/block.svg';
import { ReactComponent as Available } from '../../assets/images/global/circle-stroke.svg';
import { ScheduleStatus } from '../physician-schedule-card-block/schedule-status';
import PhysicianScheduleIndividualAPI from './physician-schedule-individual-api';
import './physician-schedule-individual.css';
let PhysicianScheduleIndividual = class PhysicianScheduleIndividual extends Component {
    renderIcon(scheduleStatusCode) {
        switch (scheduleStatusCode) {
            case ScheduleStatus.AVAILABLE:
                return React.createElement(Available, null);
            case ScheduleStatus.BLOCKED:
                return React.createElement(Blocked, null);
            default:
                return React.createElement(Available, null);
        }
    }
    renderContent() {
        const { scheduleStatusCode } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("hr", { className: 'c-appointment-detail-line' })),
            React.createElement("div", { className: 'c-appointment-detail__content' },
                React.createElement("div", { className: 'c-appointment-detail__content-right' }, this.renderIcon(scheduleStatusCode)),
                React.createElement("div", { className: 'c-appointment-detail__content-left' },
                    React.createElement("span", { className: 'c-appointment-detail-title' }, MessageService.translate('label.status')),
                    React.createElement("span", { className: 'c-appointment-detail-description' }, scheduleStatusCode === 50 ? MessageService.translate('tws.label-blocked') : MessageService.translate('tws.label-available'))))));
    }
    render() {
        return (React.createElement("div", { className: 'c-appointment-detail' }, this.renderContent()));
    }
};
PhysicianScheduleIndividual = __decorate([
    AwesomeComponent({ api: PhysicianScheduleIndividualAPI, type: ComponentType.DATA_DISPLAY })
], PhysicianScheduleIndividual);
export default PhysicianScheduleIndividual;
//# sourceMappingURL=physician-schedule-individual.js.map